<template>
  <Layout>
    <div class="row app-user-avatar">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="card-body-form">
              <div class="row">
                <div class="col-md-5">
                  <div class="mb-3">
                    <label>新手机号</label>
                    <input
                      v-model="item.phone"
                      type="text"
                      class="form-control"
                      placeholder="请输入新手机号"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-5">
                  <div class="mb-3">
                    <label>验证码</label>
                    <div style="position: relative;">
                      <input
                        v-model="item.verifyCode"
                        type="text"
                        class="form-control"
                        placeholder="请输入验证码"
                      />
                      <a
                        v-if="!sendMsgDisabled"
                        style="position: absolute;right: 0;top: 0;padding: 0.47rem 0.75rem;font-size: 0.8125rem;font-weight: 400;line-height: 1.5;"
                        @click="getPhoneCode()"
                        href="javascript:void(0);"
                      >
                        获取验证码
                      </a>
                      <a
                        v-if="sendMsgDisabled"
                        href="javascript:void(0);"
                        style="color: #C0C4CC; position: absolute;right: 0;top: 0;padding: 0.47rem 0.75rem;font-size: 0.8125rem;font-weight: 400;line-height: 1.5;"
                      >
                        {{ codeTime }}s之后重新获取
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row submit-bar">
              <div class="col-md-5">
                <div class="bar-handle" v-if="power['编辑']">
                  <button
                    @click="submitPreserve()"
                    class="btn-sm btn btn-primary"
                    type="button"
                  >
                    提交
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import user from "../../../server/api/user";
import imageUpload from "../../../components/imageUpload";

export default {
  components: {
    Layout,
    imageUpload,
  },
  data() {
    return {
      item: {},
      index_id: true,
      codeTime: 59,
      sendMsgDisabled: false,
      power: "",
    };
  },

  mounted() {
    this.power = this.utils.currentPower("创作平台-用户中心");
    // // 获取详情
    // if (this.$route.query.id) {
    //   this.index_id = this.$route.query.id;
    //   this.fetch()
    // }
  },

  methods: {
    fetch() {
      var params = {
        id: this.index_id,
      };
      content.detail(params).then((resp) => {
        if (resp.code == 0) {
        }
      });
    },

    submitPreserve() {
      let params = JSON.parse(JSON.stringify(this.item)); //copy对象
      if (!params.phone) {
        Vue.swal("请输入新手机号");
        return;
      }
      if (!params.verifyCode) {
        Vue.swal("请输入验证码");
        return;
      }
      if (this.index_id) {
        user.phoneModify(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "保存成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            // this.goBack()
          } else {
            Vue.swal(resp.msg);
          }
        });
      } else {
        content.createVideo(params).then((resp) => {
          if (resp.code == 0) {
            Vue.swal({
              icon: "success",
              title: "保存成功！",
              showConfirmButton: false,
              timer: 1000,
            });
            this.goBack();
          } else {
            Vue.swal(resp.msg);
          }
        });
      }
    },

    getPhoneCode() {
      let _this = this;
      if (!_this.item.phone) {
        Vue.swal("请输入新手机号");
        return;
      }
      let params = {
        phone: _this.item.phone,
      };
      user.sendMsg(params).then((resp) => {
        if (resp.code == 0) {
          Vue.swal({
            icon: "success",
            title: "发生成功！",
            showConfirmButton: false,
            timer: 1000,
          });
          _this.sendMsgDisabled = true;
          let codeInterval = window.setInterval(function() {
            if (_this.codeTime-- <= 0) {
              _this.codeTime = 59;
              _this.sendMsgDisabled = false;
              window.clearInterval(codeInterval);
            }
          }, 1000);
        } else {
          Vue.swal(resp.msg);
        }
      });
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.app-user-avatar .submit-bar {
  text-align: center;
}

.app-user-avatar .submit-bar .bar-handle {
  display: inline-block;
  float: inherit;
}

.app-user-avatar .submit-bar .bar-handle button {
  margin-left: 0;
}

.app-user-avatar .app-image-upload {
  display: inline-block;
}

.app-user-avatar .app-image-upload .avatar-uploader .el-upload {
  border-radius: 50%;
}
</style>
